/*
    Name : DataStore
    Description : Data structuring for the application
                  Stores recurring resources...
                  Such as images/profile data etc.
*/
class DataStore {
    constructor(name) {
        this.queue = [];
        var config = {};
        this.store = {};
        this.name = name;
        config.localcache = true;
        this.config = config;
        if (this.config.localcache) {
            var tmp = JSON.parse(localStorage.getItem(this.name));
            if (tmp) {
                this.store = tmp;
            }
            for (var d in tmp) {
                if (tmp.hasOwnProperty(d)) {
                    this.queue.push(d);
                }
            }
        }
        return this;
    }
    _getStore() {
        return this.store;
    }
    _getQueue() {
        return this.queue;
    }
    _pushToQueue(id) {
        this.queue.push(id);
    }
    _inQueue(id) {
        for (var i = 0; i < this.queue.length; i++) {
            if (this.queue[i] === id)
                return true;
        }
        return false;
    }
    _removeOldestValue() {
        this.store = JSON.parse(localStorage.getItem(this.name));
        var id = this.queue.shift();
        delete this.store[id];
        localStorage.setItem(this.name, JSON.stringify(this.store));
    }
    setItem(id, val) {
        if (this.config.localcache) {
            var self = this;
            try {
                self.store[id] = val;
                localStorage.setItem(this.name, JSON.stringify(this.store));
                if (!this._inQueue(id))
                    this._pushToQueue(id);
            }
            catch (e) {
                console.log(e);
                self._removeOldestValue();
                self.set(id, val);
            }
        }
        else {
            this.store[id] = val;
        }
    }

    getItem(key) {
        return this.store[key];
    }
}

let instance = new DataStore('app_datastore')
export default instance









// WEBPACK FOOTER //
// ./src/common/dataStore.js